import React, { useState } from "react";
import "../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import api from "../util/axios";

const AcceptRequisition = ({
  handleApproveModal,
  details,
  setAccProveModal,
}: any) => {
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  const [sign, setSign] = useState({
    remark: "",
    status: "",
    approvalRemark: "",
    approvalArea: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChanges = ({ target: { name, value } }: any) => {
    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .patch(
        `/requisition/${details._id}`,
        {
          status: "APPROVED",
          remark: details.remark,
          approvalRemark: sign.approvalRemark,
          approvalArea: sign.approvalArea,
        },
        { headers: headers }
      )

      .then((res) => {
        // console.log(res);
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          // cancelButtonColor: "red",
          confirmButtonText: "Continue",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);
        setAccProveModal(false);
        setTimeout(() => {
          navigate("/dashboard/approval");
        }, 4000);
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        setLoading(false);
      });
  };
  return (
    <div className="modal">
      <form onSubmit={handleSubmit} className="catModal">
        <div className="catModalTop">
          <h4>Approve</h4>
          <ImCancelCircle className="catCancel" onClick={handleApproveModal} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput">
          <input
            type="text"
            placeholder="Approval area"
            name="approvalArea"
            value={sign.approvalArea}
            onChange={handleChanges}
          />
          <textarea
            placeholder=" remarks"
            name="approvalRemark"
            value={sign.approvalRemark}
            onChange={handleChanges}
          ></textarea>
        </div>

        <div className="catModalBtn">
          <button type="submit" className="catBtn1">
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Approve"
            )}
          </button>
          <button className="catBtn2" onClick={handleApproveModal}>
            Back
          </button>
        </div>
      </form>
    </div>
  );
};

export default AcceptRequisition;
